"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var DragAround_1 = __importDefault(require("../Draggable/DragAround"));
var Draggable_1 = require("../Draggable/Draggable");
var HandItem_1 = __importDefault(require("./HandItem"));
function DraggableHandItem(_a) {
    var children = _a.children, _b = _a.drag, type = _b.type, item = _b.item, options = _b.options, previewOptions = _b.previewOptions, end = _b.end, canDrag = _b.canDrag, isDragging = _b.isDragging, drop = _b.drop, draggableProps = __rest(_b, ["type", "item", "options", "previewOptions", "end", "canDrag", "isDragging", "drop"]), css = _a.css, props = __rest(_a, ["children", "drag", "css"]);
    var _c = (0, react_dnd_1.useDrag)({
        type: type,
        item: item,
        options: options,
        previewOptions: previewOptions,
        end: (0, Draggable_1.endWithDrop)(end, drop),
        canDrag: canDrag,
        isDragging: isDragging,
        collect: function (monitor) { return ({ draggable: monitor.canDrag(), dragging: monitor.isDragging() }); }
    }), _d = _c[0], draggable = _d.draggable, dragging = _d.dragging, ref = _c[1], preview = _c[2];
    (0, react_2.useEffect)(function () {
        preview((0, react_dnd_html5_backend_1.getEmptyImage)());
    }, []);
    return ((0, jsx_runtime_1.jsx)(HandItem_1.default, __assign({ ref: ref, itemSelector: "> * > * > *", css: [css, draggable && Draggable_1.grabCursor, dragging && draggingStyle] }, props, { children: (0, jsx_runtime_1.jsx)(DragAround_1.default, __assign({ dragging: dragging, css: fullSize }, draggableProps, { children: children })) })));
}
exports.default = DraggableHandItem;
var draggingStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["z-index: 1000;"], ["z-index: 1000;"])));
var fullSize = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n"], ["\n  height: 100%;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2;
